import { g as d } from "../../utils-BOfnFgIH.js";
import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as e } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconFilter",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(r).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, f = ["aria-label", "data-qa", "aria-hidden"], m = ["clip-path"], p = ["id"];
function _(a, t, l, h, g, i) {
  return n(), o("svg", {
    "aria-label": l.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--filter"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Filter",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    e("g", {
      "clip-path": `url(#${a.uniqueID}a)`
    }, [...t[0] || (t[0] = [
      e("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M.547 1.29A.5.5 0 0 1 1 1h10a.5.5 0 0 1 .382.823L7.5 6.413V10.5a.5.5 0 0 1-.723.447l-2-1A.5.5 0 0 1 4.5 9.5V6.413L.618 1.823a.5.5 0 0 1-.071-.533Zm1.53.71 3.305 3.907a.5.5 0 0 1 .118.323v2.961l1 .5v-3.46a.5.5 0 0 1 .118-.324L9.923 2H2.078Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, m),
    e("defs", null, [
      e("clipPath", {
        id: `${a.uniqueID}a`
      }, [...t[1] || (t[1] = [
        e("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, f);
}
const S = /* @__PURE__ */ u(c, [["render", _]]);
export {
  S as default
};
//# sourceMappingURL=filter.js.map
